import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { PortalProvider } from '@nobia/zeus-components/lib/portal'
import { OverlayDestination } from '@nobia/zeus-components/lib/overlay'

import ErrorBoundary from '@nobia/zeus-components/lib/errorBoundary'
import Gallery from './containers/gallery'

class App extends React.Component {
  static async getInitialProps(ctx) {
    const path = ctx.req ? ctx.req.url : ctx.location && ctx.location.pathname
    return { path }
  }

  render() {
    return (
      <ErrorBoundary>
        <PortalProvider>
          <Fragment>
            <Gallery embedBlockId={this.props.embedBlockId} />
            <OverlayDestination />
          </Fragment>
        </PortalProvider>
      </ErrorBoundary>
    )
  }
}

App.defaultProps = {
  embedBlockId: null,
}

App.propTypes = {
  embedBlockId: PropTypes.string,
}

export default App
